import { createContext, Dispatch, SetStateAction } from "react";

export interface LayoutContext {
    setShowCoverImage?: Dispatch<SetStateAction<boolean>>;
}
export const LayoutContext = createContext<LayoutContext>({});
